
const DirecitveEntryExecutionEntryCanceled = () => {
  return (
    <p className="text-danger-soft">
      Proposta declinada
    </p>
  );
}

export default DirecitveEntryExecutionEntryCanceled;
